import { Component } from '@angular/core';

@Component({
  selector: 'footer',
  template: require('./footer.template.html')
})
export class FooterComponent {
  public dt:Date = new Date();
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/components/common/footer/footer.component.ts